import styled from "styled-components";



export const ButtonStyled = styled.button`
    width: 128px;
    height: 32px;
    background: #212121;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    color: #FFFFFF;
    font-family: 'Lato Bold';
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    >.c_img {
        height: 20px;
        width: 20px;
        >img {
        max-height: 100%;
        max-width: 100%;
        }
    }
`
